import cs from 'classnames';
import { useRouter } from 'next/router';
import { type FC, useMemo } from 'react';
import { CrownStarBold } from 'solar-icons';
import { Button } from '@/DesignSystem/Component';
import { VALUE_TAB } from '@/Module/Auth/Component/WelcomeSuggestSubscription/WelcomeSubscriptionTab';
import { APPLICATION_LINK, LINKS } from '@/Module/Core/Constant';
import SubscriptionDescriptionNew from '@/Module/Subscription/Component/SubscriptionDescription/SubscriptionDescriptionNew';
import SubscriptionCourseList from '@/Module/Subscription/Component/SubscriptionHistory/SubscriptionLessonSingle/SubscriptionCourseList';
import { preparePersianTime } from '@/Module/Subscription/Help';
import type { ISubscriptionsV2User } from '@/Module/Subscription/Model/DataModel';
interface ISubscriptionHistoryPreviousActiveProps {
  subscriptionActive: ISubscriptionsV2User;
}
interface ClassColor {
  title: string;
}
const COLOR_ITEM: Record<string, ClassColor> = {
  green: {
    title: 'text-greenFour'
  },
  blue: {
    title: 'text-greenFour'
  },
  pink: {
    title: 'text-pinkFour'
  },
  orange: {
    title: 'text-orangeFour'
  }
};
const SubscriptionHistoryPreviousActive: FC<ISubscriptionHistoryPreviousActiveProps> = ({
  subscriptionActive
}) => {
  const router = useRouter();
  const id = useMemo(() => {
    if (subscriptionActive?.subscriptionPlanId === 177 || subscriptionActive?.subscriptionPlanId === 186) {
      return '';
    }
    return subscriptionActive?.subscriptionPlanId;
  }, [subscriptionActive]);
  const onClickHandler = () => {
    router.push(`${APPLICATION_LINK}/${LINKS.SUBSCRIPTION.MAIN}/${id}`);
  };
  const remainingDays = useMemo(() => {
    return <div className="text-redTwo">
        « <span>{subscriptionActive?.remainingDays !== 0 ? subscriptionActive?.remainingDays : 1}</span>
        <span> روز باقی مانده</span> »
      </div>;
  }, [subscriptionActive?.remainingDays]);
  const time = preparePersianTime({
    persianDate: subscriptionActive?.persianEndDate
  });
  return <div className=" flex w-full flex-col  rounded-2xl border-[1px] border-blackTwo p-6" data-sentry-component="SubscriptionHistoryPreviousActive" data-sentry-source-file="SubscriptionHistoryPreviousActive.tsx">
      <div className="flex w-full flex-row">
        <div className={cs('border-[1px] w-[56px] h-[56px] flex justify-center items-center rounded-full ml-4', COLOR_ITEM[subscriptionActive.color]?.title)}>
          <CrownStarBold className={cs('', COLOR_ITEM[subscriptionActive.color]?.title)} data-sentry-element="CrownStarBold" data-sentry-source-file="SubscriptionHistoryPreviousActive.tsx" />
        </div>
        <div className="w-full flex-1">
          <h2 className="mb-2   text-right  font-semibold text-blackFive">
            {subscriptionActive.subscriptionName?.split('_')[0]}
          </h2>
          <h3 className={cs('mb-2 text-sm', COLOR_ITEM[subscriptionActive.color]?.title)}>
            {subscriptionActive.subscriptionName?.split('_')[1]} {subscriptionActive?.subscriptionType}
          </h3>
          <div className="flex flex-row justify-between text-sm">
            <div className="relative pr-3 before:absolute before:right-0 before:top-2 before:h-[4px] before:w-[4px] before:rounded-full before:bg-blackSix">
              {' '}
              اشتراک {VALUE_TAB[subscriptionActive?.totalDays]?.month}{' '}
            </div>
            <div className="mb-0 text-center">{remainingDays}</div>
          </div>
        </div>
      </div>
      {subscriptionActive?.subscriptionType === 'فروشگاهی' && <SubscriptionCourseList coursers={subscriptionActive?.courses} />}
      <div className="my-4 ">
        <span>این اشتراک تا تاریخ </span>
        <span>
          {time.day} {time.month} {time.year}
        </span>
        <span>، ساعت {time.clock} </span>
        <span>{time.wrap} فعال می‌باشد.</span>
      </div>
      <SubscriptionDescriptionNew subscriptionDescription={subscriptionActive?.subscriptionPlanDescription} data-sentry-element="SubscriptionDescriptionNew" data-sentry-source-file="SubscriptionHistoryPreviousActive.tsx" />
      <div className="mb-4 flex justify-center lg:mb-4">
        <Button onClick={onClickHandler} className=" mt-6 w-full " variant="shadow" color="BLUE" radius="round" size="middle" bold data-sentry-element="Button" data-sentry-source-file="SubscriptionHistoryPreviousActive.tsx">
          تمدید اشتراک
        </Button>
      </div>
    </div>;
};
export default SubscriptionHistoryPreviousActive;